import { gql } from "graphql-tag";

import { getSeoFields, getMetaFields } from "~/mixins/seoMixin";
import { heroCarouselV2 } from "~/slices/HeroCarouselV2/fragment";
import { getProductCatalogueV2 } from "~/slices/ProductCatalogueV2/fragment";
import { instagramV2 } from "~/slices/InstagramV2/fragment";
import { customerReviewV2 } from "~/slices/CustomerReviewV2/fragment";
import { getTopCategoryV2 } from "~/slices/TopCategoryV2/fragment";
import { getCallToActionV2 } from "~/slices/CallToActionV2/fragment";
import { getListOfArticlesV2 } from "~/slices/ListOfArticlesV2/fragment";
import { shopByStyleV2 } from "~/slices/ShopByStyleV2/fragment";
import { getNewsSubscriptionV2 } from "~/slices/NewsSubscriptionV2/fragment";
import { getImageSectionV2 } from "~/slices/ImageSectionV2/fragment";
import { getShopByOfferV2 } from "~/slices/ShopByOfferV2/fragment";

const PAGE_TYPE = "Home_page_v2";

const QUERY_HOMEPAGE = gql`
  query home_page_v2($uid: String!, $lazy: Boolean!, $lang: String = "en-in") {
    ${PAGE_TYPE}:home_page_v2(uid: $uid, lang: $lang) {
        title
      ...${PAGE_TYPE}SEOFields
      ...${PAGE_TYPE}MetaFields
      slices {
        ...${PAGE_TYPE}_hero_carousel_v2
        ...${PAGE_TYPE}_product_catalogue_v2
        ...${PAGE_TYPE}_instagram_v2
        ...${PAGE_TYPE}_customer_review_v2
        ...${PAGE_TYPE}_call_to_action_v2
        ...${PAGE_TYPE}_top_category_v2
        ...${PAGE_TYPE}_list_of_articles_v2
        ...${PAGE_TYPE}_shop_by_style_v2
        ...${PAGE_TYPE}_news_subscription_v2
        ...${PAGE_TYPE}_image_section_v2
        ...${PAGE_TYPE}_shop_by_offer_v2
      }
    }
  }
  ${getSeoFields(PAGE_TYPE)}
  ${getMetaFields(PAGE_TYPE)}
  ${heroCarouselV2}
  ${getProductCatalogueV2(PAGE_TYPE, true)}
  ${instagramV2}
  ${customerReviewV2}
  ${getTopCategoryV2(PAGE_TYPE, true)}
  ${getCallToActionV2(PAGE_TYPE, true)}
  ${getListOfArticlesV2(PAGE_TYPE)}
  ${shopByStyleV2}
  ${getNewsSubscriptionV2(PAGE_TYPE)}
  ${getImageSectionV2(PAGE_TYPE, true)}
  ${getShopByOfferV2(PAGE_TYPE, "Slices")}`;

export { QUERY_HOMEPAGE, PAGE_TYPE };
